var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2562,
    height: 36,
    viewBox: "0 0 2562 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_1392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2562,
    height: 36,
    fill: "#FBF6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.5 32.5287V-14.3848V-31L2772 -47V3.5C2772 3.5 2232.5 34.5 1976.5 24.0287C1818.63 17.5714 1736.63 27.0781 1663 24.0287C1389.72 12.7117 1308 18.2918 1153.5 24.0287C998.998 29.7657 689.497 40.9664 466.497 24.0287C288.097 10.4786 48.3333 27.479 -49.5 32.5287Z",
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0287V-28.4233V-47H2562V3.5C2562 3.5 2022.5 34.5 1766.5 24.0287C1608.63 17.5714 1526.63 27.0781 1453 24.0287C1179.72 12.7117 1098 18.2918 943.497 24.0287C788.997 29.7657 479.498 40.9664 256.498 24.0287C78.0975 10.4786 97.8333 18.3829 0 24.0287Z",
    fill: "#3AB700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2562 19.0287V-33.4233V-52H0V-1.5C0 -1.5 539.5 29.5 795.5 19.0287C953.368 12.5714 1035.37 22.0781 1109 19.0287C1382.28 7.71167 1464 13.2918 1618.5 19.0287C1773 24.7657 2082.5 17.9664 2305.5 1.02875C2483.9 -12.5214 2464.17 13.3829 2562 19.0287Z",
    fill: "#46382C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_1392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2562,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRibbon);
export default __webpack_public_path__ + "static/media/top-ribbon.cdbfb27069ea23e3468c97bce60d3e11.svg";
export { ForwardRef as ReactComponent };